export default "__VITE_ASSET__28bfe174__"